// extracted by mini-css-extract-plugin
export default {"button_group":"DropsOfMemory_button_group__EbaQ3"};